import React, { FC, MutableRefObject, ReactNode, useState } from 'react';
// import { makeStyles, createStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import styled from '@mui/material/styles/styled';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { SxProps } from '@mui/material/styles';

export enum TwInputTypes {
  text = 'text',
  number = 'number',
  password = 'password',
  textarea = 'textarea',
  textareaAuto = 'textareaAuto'
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  // backgroundColor: ({ disabled }) => (disabled ? 'rgba(0, 0, 0, 0.03)' : '#fff'),
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '21px',
  width: '100%',
  marginBottom: '8px',
  padding: '0',

  '& .MuiOutlinedInput-root': {
    height: '40px'
  },

  '& input': {
    fontFamily: 'Poppins',
    fontSize: '14px',
    backgroundColor: '#fff',

    '&:placeholder': {
      color: '#B5B5BE'
    }
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#3959df'
  },

  '& .MuiOutlinedInput-input.Mui-disabled': {
    background: 'rgba(0, 0, 0, 0.03) !important'
  },

  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .MuiSvgIcon-root': {
    width: '0.8em',
    height: '0.8em'
  },

  '& .MuiIconButton-root': {
    padding: '0',
    color: '#7e858e'
  },

  '& .Mui-disabled': {
    paddingLeft: '0px',
    '& .MuiTypography-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
      padding: '9px 0 9px 14px',
      margin: '0',
      textAlign: 'center'
    },
    '& .MuiInputBase-input': {
      paddingLeft: '14px'
    }
  }
}));

const StyledTextArea = styled(TextareaAutosize)(({ theme }) => ({
  // backgroundColor: ({ disabled }) => (disabled ? 'rgba(0, 0, 0, 0.03)' : '#fff'),
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '21px',
  width: '100%',
  marginBottom: '8px',
  minHeight: '110px',
  overflow: 'auto !important',
  resize: 'none',
  padding: '8.5px 14px',
  border: '1px solid',
  borderColor: '#E2E2EA',
  borderRadius: '4px',

  '&::placeholder': {
    color: '#B5B5BE'
  },

  '& .MuiOutlinedInput-root': {
    height: '40px'
  },

  '& input': {
    fontFamily: 'Poppins',
    fontSize: '14px',
    backgroundColor: 'white',

    '&:placeholder': {
      color: '#B5B5BE'
    }
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#3959df'
  },

  '& .MuiOutlinedInput-input.Mui-disabled': {
    background: 'rgba(0, 0, 0, 0.03)'
  },

  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .MuiSvgIcon-root': {
    width: '0.8em',
    height: '0.8em'
  },

  '& .MuiIconButton-root': {
    padding: '0',
    color: '#7e858e'
  },

  '& .Mui-disabled': {
    paddingLeft: '0px',
    '& .MuiTypography-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
      padding: '9px 0 9px 14px',
      margin: '0',
      textAlign: 'center'
    },
    '& .MuiInputBase-input': {
      paddingLeft: '14px'
    }
  }
}));

const TextAreaAuto = styled(TextareaAutosize)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '14px',
  width: '100%',
  marginBottom: '8px',
  overflow: 'auto !important',
  padding: '8.5px 14px',
  border: '1px solid',
  borderColor: '#E2E2EA',
  borderRadius: '4px',
  resize: 'none', // disable textarea resizing grabber that appears in the bottom right corner
  '&::placeholder': {
    color: '#B5B5BE'
  },

  '& .MuiOutlinedInput-root': {
    height: '40px'
  },

  '& input': {
    fontFamily: 'Poppins',
    fontSize: '14px',
    backgroundColor: 'white',

    '&:placeholder': {
      color: '#B5B5BE'
    }
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#3959df'
  },

  '& .MuiOutlinedInput-input.Mui-disabled': {
    background: 'rgba(0, 0, 0, 0.03)'
  },

  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E2EA'
  },

  '& .MuiSvgIcon-root': {
    width: '0.8em',
    height: '0.8em'
  },

  '& .MuiIconButton-root': {
    padding: '0',
    color: '#7e858e'
  },

  '& .Mui-disabled': {
    paddingLeft: '0px',
    '& .MuiTypography-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
      padding: '9px 0 9px 14px',
      margin: '0',
      textAlign: 'center'
    },
    '& .MuiInputBase-input': {
      paddingLeft: '14px'
    }
  }
}));

export const StyledTextfieldLabel = styled('span')(({ theme }) => ({
  display: 'block',
  color: '#7e858e',
  fontSize: '14px',
  padding: '4px 0',
  fontWeight: 500
}));

export interface TwFieldProps {
  /**
   * Label text for the Field.
   */
  label?: string | ReactNode;
  /**
   * Id for the Field.
   */
  id?: string;
  /**
   * className for the container.
   */
  className?: string;
  /**
   * Type of the Field: number, text, password, etc.
   */
  inputType?: TwInputTypes;
  /**
   * Field editable status.
   */
  disabled?: boolean;
  /**
   * Text for the placeholder, if any.
   */
  placeholder?: string;
  /**
   * Callback fired when input value is changed.
   */
  onInputChange?: (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  /**
   * Callback fired when input loses focus
   */
  onInputBlur?: (
    e: React.FocusEvent<HTMLInputElement> | React.FocusEvent<HTMLTextAreaElement>
  ) => void;
  /**
   * Field name
   */
  name: string;
  /**
   * Field value
   */
  value?: string | number | undefined;
  /**
   * Field has error flag
   */
  error?: boolean;
  /**
   * Helper text for the errors
   */
  helperText?: string | undefined;
  /**
   * Adorment to appear at start of the input.
   */
  startAdorment?: ReactNode;
  /**
   * Adorment to appear at the end of the input.
   */
  endAdorment?: ReactNode;
  /**
   * Autocomplete option
   */
  autoComplete?: string;
  /**
   * Input ref
   */
  inputRef?: MutableRefObject<HTMLInputElement | undefined>;
  /**
   *  can be used to make the input take up the full width of its container.
   */
  fullWidth?: boolean;
  /**
   * keyDown handler
   */
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  /**
   * keyDown handler
   */
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  highlight?: boolean;
  /**
   * Sx prop
   */
  sx?: SxProps;
  /**
   * maxRows for the textarea
   */
  maxRows?: number;
  /**
   * readOnly flag
   */
  readOnly?: boolean;
}

const TwField: FC<TwFieldProps> = ({
  label,
  id,
  disabled,
  placeholder,
  className,
  name,
  value,
  error,
  helperText,
  inputType,
  startAdorment,
  endAdorment,
  autoComplete,
  inputRef,
  onInputChange,
  onInputBlur,
  fullWidth = false,
  onKeyDown,
  onKeyUp,
  highlight,
  sx,
  maxRows,
  readOnly = false
}) => {
  const inputTypeClass =
    inputType === TwInputTypes.text
      ? 'tid-field tid-field-text'
      : inputType === TwInputTypes.number
      ? 'tid-field tid-field-number'
      : inputType === TwInputTypes.password
      ? 'tid-field tid-field-password'
      : '';

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = (): void => {
    setShowPassword((showPassword) => !showPassword);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
  };

  const ToggleVisibilityButton = (): JSX.Element => {
    return (
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
      >
        {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
      </IconButton>
    );
  };

  const captureKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (inputType === TwInputTypes.number && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
    }
    onKeyDown && onKeyDown(e);
  };

  const captureOnWheel = (e: any): void => {
    if (inputType === TwInputTypes.number) {
      e.target.blur();
    }
  };

  return (
    <div className={`${inputTypeClass} ${className ? className : ''}`}>
      {label && (
        <label className="tid-field-label" htmlFor={id}>
          <StyledTextfieldLabel style={{ paddingBottom: '4px' }}>{label}</StyledTextfieldLabel>
        </label>
      )}

      {inputType === TwInputTypes.password && (
        <StyledTextField
          id={id}
          name={name}
          value={value}
          onChange={onInputChange}
          onBlur={onInputBlur}
          type={showPassword ? TwInputTypes.text : TwInputTypes.password}
          inputRef={inputRef}
          disabled={disabled}
          size="small"
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          autoComplete={autoComplete}
          InputProps={{
            endAdornment: (
              <div
                className={
                  showPassword
                    ? 'tid-field-icon tid-field-visibility-off-icon'
                    : 'tid-field-icon tid-field-visibility-on-icon'
                }
              >
                <InputAdornment position="end">
                  <ToggleVisibilityButton />
                </InputAdornment>
              </div>
            )
          }}
          fullWidth={fullWidth}
        />
      )}

      {inputType !== TwInputTypes.password &&
        inputType !== TwInputTypes.textarea &&
        inputType !== TwInputTypes.textareaAuto && (
          <StyledTextField
            id={id}
            name={name}
            value={value}
            onChange={onInputChange}
            onBlur={onInputBlur}
            type={inputType || 'text'}
            inputRef={inputRef}
            disabled={disabled}
            size="small"
            placeholder={placeholder}
            error={error}
            helperText={helperText}
            InputProps={{
              startAdornment: startAdorment,
              endAdornment: endAdorment,
              sx: {
                border: highlight ? '1px solid #FCA5A5' : undefined,
                borderRadius: '4px',
                backgroundColor: disabled ? 'rgba(0, 0, 0, 0.03)' : '#fff'
              },
              readOnly
            }}
            fullWidth={fullWidth}
            onKeyDown={captureKeyDown}
            onKeyUp={onKeyUp ?? undefined}
            onWheel={captureOnWheel}
            sx={sx}
          />
        )}

      {inputType === TwInputTypes.textarea && (
        <StyledTextArea
          id={id}
          name={name}
          value={value}
          onBlur={onInputBlur}
          onChange={onInputChange}
          disabled={disabled}
          placeholder={placeholder}
          maxRows={maxRows}
        />
      )}

      {inputType === TwInputTypes.textareaAuto && (
        <TextAreaAuto
          id={id}
          name={name}
          value={value}
          onBlur={onInputBlur}
          onChange={onInputChange}
          disabled={disabled}
          placeholder={placeholder}
          maxRows={maxRows}
          readOnly={readOnly}
        />
      )}
    </div>
  );
};

export default TwField;
